var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHovered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Canvas",
    transform: "translate(12975 -5244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Oval_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path0_fill",
    transform: "matrix(1 1.74267e-08 -1.74267e-08 1 -12975 5244)",
    fill: "#494949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12959.5 5259.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12952.5 5259.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12945.5 5259.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12959.5 5266.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12952.5 5266.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12945.5 5266.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12959.5 5273.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_7"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12952.5 5273.5)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-hovered_svg__logo-hovered_svg__Rectangle_20_8"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-hovered_svg__logo-hovered_svg__path1_fill",
    transform: "matrix(1 0 0 1 -12945.5 5273.5)",
    fill: "#FFFFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-hovered_svg__logo-hovered_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 25 50C 38.8071 50 50 38.8071 50 25C 50 11.1929 38.8071 0 25 0C 11.1929 0 0 11.1929 0 25C 0 38.8071 11.1929 50 25 50Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-hovered_svg__logo-hovered_svg__path1_fill",
    d: "M 0 0L 5 0L 5 5L 0 5L 0 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHovered);
export default __webpack_public_path__ + "static/media/logo-hovered.55a3e58fc421966d93f27260c8686b9e.svg";
export { ForwardRef as ReactComponent };